// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4ea0574b","635":"6d5f1290"}[chunkId] + ".chunk.js";
};